<template>
    <layout v-bind:user="user" v-bind:brands="brands" v-bind:shops="shops" v-bind:company="company" v-bind:title="pageName">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <div class="main"><span>個人設定</span></div>
                <div class="controller flex _right _y-center" v-if="getPersonalPlanAdmin">
                    <div>
                        <button class="btn_link _cancel md_icon-text" v-on:click="clickRecessCompany()">
                            <div class="inner">
                                <span v-if="company.status == 0"><div class="icon"><SvgIconDelete /></div>休会中</span>
                                <span v-if="company.status == 1"><div class="icon"><SvgIconDelete /></div>休会</span>
                            </div>
                        </button>
                    </div><!--/.add-->
                    <div>
                        <button class="btn_link _cancel md_icon-text" v-on:click="clickDeleteCompany()">
                            <div class="inner">
                                <span><div class="icon"><SvgIconDelete /></div>退会</span>
                            </div>
                        </button>
                    </div><!--/.add-->
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->

                <div class="us_component form_admin-container">

                    <swiper
                        class="switch-btn-wrap"
                        :slides-per-view="2.5"
                        :space-between="0"
                        :mousewheel="true"
                        :speed="500"
                        :breakpoints='{
                            "768": {
                                "slidesPerView": 3.5,
                            },
                            "1024": {
                                "slidesPerView": 5.5,
                            },
                        } '
                    >
                        <template  v-if="pageType == 1" >
                            <swiper-slide class="switch-btn _current">
                                <label for="contents0"><span>ユーザー情報</span></label>
                            </swiper-slide>
                            <swiper-slide class="switch-btn">
                                <label for="contents1"><span>通知設定</span></label>
                            </swiper-slide>
                            <swiper-slide class="switch-btn">
                                <label for="contents2"><span>パスワード設定</span></label>
                            </swiper-slide>
                        </template>

                        <template  v-if="pageType == 2" >
                            <swiper-slide class="switch-btn">
                                <label for="contents3"><span>パスワード設定</span></label>
                            </swiper-slide>
                        </template>

                    </swiper>

                    <template  v-if="pageType == 1" >
                        <!-- ユーザー情報 :::::::::::::::::::::::::::::::::::::::-->
                        <input type="radio" name="switch-content1" id="contents0" checked>
                        <div class="switch-contents">
                            <div class="md_common-bl _padding-add">
                                <div class="inner">

                                    <form v-on:submit.prevent="userPost">
                                        <!-- UserInfoWrap -->
                                        <div class="user-info-wrap">

                                            <!-- LeftColumn -->
                                            <div class="block">

                                                <!--UserAvatar-->
                                                <div class="avatar-image-wrap">
                                                    <input type="file" id="user-avatar" accept="image/*" data-preview="_user-avatar" v-on:change="selectedFile" ref="ref_file">
                                                    <label for="user-avatar"></label>
                                                    <img class="preview _user-avatar" v-bind:src="icon">
                                                    <div class="no-image">
                                                        <SvgIconImagePlace />
                                                    </div>
                                                </div>
                                                <div class="avatar-image-control">
                                                    <!-- Delete -->
                                                    <button type="button" class="btn_svg-icon" v-on:click="deleteIcon()">
                                                        <SvgIconDelete />
                                                    </button>
                                                    <!-- Reload -->
                                                    <label for="user-avatar" class="btn_svg-icon">
                                                        <SvgIconReload />
                                                    </label>
                                                </div>

                                            </div><!-- /LeftColumn -->

                                            <!-- RightColumn -->
                                            <div class="block">

                                                <!-- 名前 -->
                                                <div class="item form_text">
                                                    <div class="input-row">
                                                        <input type="text" maxlength="250" id="user-name" v-model="name" v-bind:class="{ '_error _required': errors.name }">
                                                    </div>
                                                    <label for="user-name" v-bind:class="{ '_error _required': errors.name }"><span>名前</span></label>
                                                </div>
                                                <!-- メールアドレス -->
                                                <div class="item form_text">
                                                    <div class="input-row">
                                                        <input type="email" id="user-email" inputmode="email" v-model="email" v-bind:class="{ '_error _required': errors.email }">
                                                    </div>
                                                    <label for="user-email" v-bind:class="{ '_error _required': errors.email }"><span>メールアドレス</span></label>
                                                </div>
                                                <!-- 電話番号 -->
                                                <div class="item form_text">
                                                    <div class="input-row">
                                                        <input type="tel" id="user-tel" inputmode="tel" pattern="[0-9]*" title="半角数字のみ" v-model="tel" v-bind:class="{ '_error _required': errors.tel }">
                                                        <!-- <span style="color: red" v-if="errors.tel">{{errors.tel}}</span> -->
                                                    </div>
                                                    <label for="user-tel" v-bind:class="{ '_error _required': errors.tel }"><span>電話番号</span></label>
                                                </div>

                                            </div><!-- /RightColumn -->

                                        </div><!-- /.user-info-wrap -->

                                        <!--btn-link-wrap-->
                                        <div class="btn_link-wrap">

                                            <!--LinkBtn - キャンセル -->
                                            <Link class="btn_link _cancel md_icon-text" :href="route('admin.account.set')">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                                </div>
                                            </Link>

                                            <!--LinkBtn - 決定アイコン -->
                                            <button class="btn_link md_icon-text _white">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                                </div>
                                            </button>

                                        </div><!--/.btn-link-wrap-->
                                    </form>

                                </div>
                            </div>
                        </div><!-- ユーザー情報 -->

                        <!-- 通知設定 :::::::::::::::::::::::::::::::::::::::-->
                        <input type="radio" name="switch-content1" id="contents1">
                        <div class="switch-contents ">
                            <div class="md_common-bl _padding-add">
                                <div class="inner">
                                    <form v-on:submit.prevent="noticePost">
                                        <!-- UserInfoWrap -->
                                        <div class="user-info-wrap">

                                            <!--::::::::::::::: .input-group :::::::::::::::-->
                                            <div class="input-group">

                                                <!-- CheckBoxItem -->
                                                <div class="item form_checkbox-text">
                                                    <input type="checkbox" name="notice-checkbox1" id="notice-checkbox1-1" v-bind:checked="notice_mail" v-on:change="changeNoticeMail()">
                                                    <label for="notice-checkbox1-1">
                                                        <div class="mark"></div>
                                                        <span>メールを受信する</span>
                                                    </label>
                                                </div>

                                                <!-- CheckBoxItem -->
                                                <div class="item form_checkbox-text">
                                                    <input type="checkbox" name="notice-checkbox1" id="notice-checkbox1-2" v-bind:checked="notice_browser" v-on:change="changeNoticeBrowser()">
                                                    <label for="notice-checkbox1-2">
                                                        <div class="mark"></div>
                                                        <p>ブラウザ通知を許可する</p>
                                                        <p class="md_text-light">このブラウザーに通知を送信する権限をAUMAに付与してください</p>
                                                    </label>
                                                </div>

                                            </div><!-- /.input-group :::::::::::::::-->

                                        </div><!-- /.user-info-wrap -->

                                        <!-- プッシュ通知が届くかテスト用 -->
                                        <!-- <button type="button" v-on:click="webPush">プッシュ通知をするテストボタン</button> -->

                                        <!--btn-link-wrap-->
                                        <div class="btn_link-wrap">

                                            <!--LinkBtn - 決定アイコン -->
                                            <button class="btn_link md_icon-text _white">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                                </div>
                                            </button>

                                        </div><!--/.btn-link-wrap-->
                                    </form>
                                </div>
                            </div>
                        </div><!-- 通知設定 -->

                        <!-- パスワード設定 (メールアドレス入力画面) :::::::::::::::::::::::::::::::::::::::-->
                        <input type="radio" name="switch-content1" id="contents2">
                        <div class="switch-contents">
                            <div class="md_common-bl _padding-add">
                                <div class="inner">
                                    <form v-on:submit.prevent="mailSubmit">
                                        <!-- UserInfoWrap -->
                                        <div class="user-info-wrap">

                                            <!--::::::::::::::: .input-group :::::::::::::::-->
                                            <div class="input-group">

                                                <p class="text">ご利用のメールアドレスに再設定用URLの記載されたメールを送信いたします。URLをクリックしてパスワードを再設定してください。</p>

                                                <!-- メールアドレス -->
                                                <!-- <div class="item form_text">
                                                    <div class="input-row">
                                                        <input type="email" id="password-email" inputmode="email">
                                                    </div>
                                                    <label for="password-email"><span>メールアドレス</span></label>
                                                </div> -->

                                            </div><!-- /.input-group :::::::::::::::-->

                                        </div><!-- /.user-info-wrap -->

                                        <!--btn-link-wrap-->
                                        <div class="btn_link-wrap">

                                            <!--LinkBtn - 決定アイコン -->
                                            <button class="btn_link md_icon-text _white">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconSend /></div>メールを送信</span>
                                                </div>
                                            </button>

                                        </div><!--/.btn-link-wrap-->
                                    </form>
                                </div>
                            </div>
                        </div><!-- パスワード設定 (メールアドレス入力画面) -->
                    </template>

                    <template  v-if="pageType == 2">
                        <!-- パスワード設定 (再設定画面) :::::::::::::::::::::::::::::::::::::::-->
                        <input type="radio" name="switch-content1" id="contents3" checked>
                        <div class="switch-contents">
                            <div class="md_common-bl _padding-add">
                                <div class="inner">

                                    <form v-on:submit.prevent="passwordPost">
                                        <!-- UserInfoWrap -->
                                        <div class="user-info-wrap">

                                            <!--::::::::::::::: .input-group :::::::::::::::-->
                                            <div class="input-group">

                                                <!-- 現在のパスワード -->
                                                <div class="item form_text _password">
                                                    <div class="input-row">
                                                        <input type="password" id="current-password" v-model="password_current" required>
                                                        <button type="button" id="passview-current" class="passview js-toggle-on"><span></span></button>
                                                    </div>
                                                    <label for="current-password"><span>現在のパスワード</span></label>
                                                </div>

                                                <!-- 新しいパスワード -->
                                                <div class="item form_text _password">
                                                    <div class="input-row">
                                                        <input type="password" id="new-password" v-model="password" required>
                                                        <button type="button" id="passview-new" class="passview js-toggle-on"><span></span></button>
                                                    </div>
                                                    <label for="new-password"><span>新しいパスワード</span></label>
                                                </div>

                                            </div><!-- /.input-group :::::::::::::::-->

                                        </div><!-- /.user-info-wrap -->

                                        <!--btn-link-wrap-->
                                        <div class="btn_link-wrap">

                                            <!--LinkBtn - 決定アイコン -->
                                            <button class="btn_link md_icon-text _white">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                                </div>
                                            </button>

                                        </div><!--/.btn-link-wrap-->
                                    </form>
                                </div>
                            </div>
                        </div><!-- パスワード設定 (メールアドレス入力画面) -->
                    </template>

                </div>
                <AlertModal
                    v-if="showAlertModal"
                    @close="closeAlertModal"
                    :title="alert_modal_title"
                    :message="alert_modal_message"
                    :mode="alert_modal_mode"
                />
                <ConfirmModalWithPromise ref="confirmModal" />
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>
<script>
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'

    import AdminLayout from '@/Layouts/AdminLayout'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import ConfirmModalWithPromise from '@/components/Admin/ComponentList/ConfirmModalWithPromise'

    //Svg
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconAdd from '@/components/EndUser/svg/SvgIconAdd'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconChat from '@/components/EndUser/svg/SvgIconChat'
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'
    import SvgIconReload from '@/components/EndUser/svg/SvgIconReload'

    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    import "swiper/css/pagination"
    import "swiper/css/navigation"

    export default {
        components: {
            "layout": AdminLayout,
            "Link": Link,
            "AlertModal": AlertModal,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
            //Swiper
            Swiper,
            SwiperSlide,
            //Svg
            SvgIconEdit,
            SvgIconCheck,
            SvgIconCancel,
            SvgIconBack,
            SvgIconBack,
            SvgIconDelete,
            SvgIconImagePlace,
            SvgIconMail,
            SvgIconChat,
            SvgIconSearch,
            SvgIconSend,
            SvgIconReload,
            SvgIconAdd
        },
        mounted() {
            if (location.pathname == '/admin/account/set') {
                ////////////////////////////////////////////////
                //  ブランド- 個人設定 - ユーザー情報
                //  ボタンのカレント表示切り替え
                ////////////////////////////////////////////////
                $('.switch-btn').on('click', function () {
                    $(this).siblings().removeClass('_current');
                    $(this).addClass('_current');
                });

                ////////////////////////////////////////////////
                //  ユーザー画像のプレビュー
                ////////////////////////////////////////////////
                $('[data-preview]').on('change', function (e) {
                    var target = $(e.target);
                    var targetPreviewSelector = target.attr('data-preview');
                    var reader = new FileReader();
                    if (!targetPreviewSelector) {
                        targetPreviewSelector = target.parents('[data-preview]').attr('data-preview');
                    }
                    if (e.target.files.length) {
                        reader.onload = function (e) {
                            $('.preview.' + targetPreviewSelector).attr('src', e.target.result);
                        }
                        reader.readAsDataURL(e.target.files[0]);
                    }
                });

            } else if (location.pathname == '/admin/account/reset/password') {
                ////////////////////////////////////////////////
                //  パスワードの一時的な可視化
                ////////////////////////////////////////////////
                window.addEventListener('DOMContentLoaded', function(){
                    // (1)パスワード入力欄とボタンのHTMLを取得
                    let passviewCurrent = document.getElementById("passview-current");
                    let currentPassword = document.getElementById("current-password");
                    // (2)ボタンのイベントリスナーを設定
                    passviewCurrent.addEventListener("click", (e)=>{
                        // (3)ボタンの通常の動作をキャンセル（フォーム送信をキャンセル）
                        e.preventDefault();
                    // (4)パスワード入力欄のtype属性を確認
                    if( currentPassword.type === 'password' ) {
                        // (5)パスワードを表示する
                        currentPassword.type = 'text';
                    } else {
                        // (6)パスワードを非表示にする
                        currentPassword.type = 'password';
                    }
                    });
                });
                window.addEventListener('DOMContentLoaded', function(){
                    // (1)パスワード入力欄とボタンのHTMLを取得
                    let passviewNew = document.getElementById("passview-new");
                    let newPassword = document.getElementById("new-password");
                    // (2)ボタンのイベントリスナーを設定
                    passviewNew.addEventListener("click", (e)=>{
                        // (3)ボタンの通常の動作をキャンセル（フォーム送信をキャンセル）
                        e.preventDefault();
                    // (4)パスワード入力欄のtype属性を確認
                    if( newPassword.type === 'password' ) {
                        // (5)パスワードを表示する
                        newPassword.type = 'text';
                    } else {
                        // (6)パスワードを非表示にする
                        newPassword.type = 'password';
                    }
                    });
                });
            }

            // ユーザー情報
            if (this.user) {
                if (this.user.icon && this.user.icon != '/img/blank.png'){
                    this.icon = this.$store.state.const.AWS_S3_URL_HOST + this.user.icon;
                    this.file_name = this.user.icon;
                }
                this.name = this.user.name;
                this.email = this.user.email;
                this.tel = this.user.tel;
            }

            // 通知設定
            if (this.user) {
                this.notice_mail = this.user.notice_mail;
                this.notice_browser = this.user.notice_browser;
            }

            if('serviceWorker' in navigator && 'PushManager' in window) {
                // Service Workerをブラウザにインストールする
                navigator.serviceWorker.register('/service-worker.js')
                    .then(registration => {
                        console.log('Service Worker が登録されました。');
                        this.registration = registration;
                        this.registration.pushManager.getSubscription()
                            .then(subscription => {
                                // this.isSubscribed = !(subscription === null);
                            });
                    });
            } else {
                console.log('このブラウザは、プッシュ通知をサポートしていません。');
            }

            //パスワード設定
            if (this.res) {
                this.openAlertModal("success", this.res.mes, this.res.mes); // 確認済み
            }

            // タブの切り替えにコンテンツの表示が追いつかない問題の対応
            setInterval(() => {
                $('#' + $('.switch-btn._current label').attr('for'))
                    .prop('checked', true);
            }, 100);
        },
        props: {
            user: Object,
            token_id: Object,
            res: Object,
            company: Object,
            shops: Object,
            brands: Object,
            errors: Object,
        },
        data() {
            return {
                // ユーザー情報
                file: '',
                file_name: '',
                icon: '/img/blank.png',
                name: '',
                email: '',
                tel: '',
                // 通知設定
                notice_mail: false,
                notice_browser: false,
                vapidPublicKey: this.$store.state.const.VAPID_PUBLIC_KEY,
                registration: null,
                // パスワード設定
                password_current: '',
                password: '',
                showAlertModal: false,
                alert_modal_title: "",
                alert_modal_message: "",
                alert_modal_mode: ""
            }
        },
        computed: {
            pageType() {
                if (location.pathname == '/admin/account/set') {
                    return 1;
                } else if (location.pathname == '/admin/account/reset/password') {
                    return 2;
                }
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                }
            },
            getPersonalPlanAdmin() {
                // ショップの管理者ユーザーでプランがPersonalのみ表示
                if (this.shops && this.user.role == 0 && this.user.type == 1) {
                    // shop [10:personal | 11: unit ]
                    if (this.shops[0].plan == 10) {
                        return true;
                    }  else if (this.shops[0].plan == 11) {
                        return false;
                    }
                } else {
                    // 0になる可能性があるのは削除機能のあるshop側ではunitだけ
                    return false;
                }
            },
        },
        methods: {
            // ユーザー情報
            userPost() {
                const form = reactive({
                    file: this.file,
                    file_name: this.file_name,
                    name: this.name,
                    email: this.email,
                    old_email: this.user.email,
                    tel: this.tel,
                })
                Inertia.post('/admin/account/set/user', form, {
                    preserveState: true,
                    preserveScroll: true,
                    onFinish: visit => {
                        if (this.user.email != this.email) {
                            this.openAlertModal("success", '送信完了', '旧メールアドレスにメールを送信しました。メールのURLをクリックして登録完了です。'); // 確認済み
                        }
                    },
                })
            },
            fileSelect() {
                const input = document.getElementById("profile");
                input.click();
            },
            selectedFile(e) {
                const files = e.target.files;
                const file = files[0];
                if (file.size > this.$store.state.const.max_file_size) {
                    this.$refs.ref_file.value = '';
                    this.openAlertModal("error", "エラー", this.$store.state.const.file_size_error); // 確認済み
                } else {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.file = file;
                        this.file_name = file.name;
                        this.icon = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
            },
            deleteIcon() {
                this.icon = '/img/blank.png';
                this.file = '';
                this.file_name = '';
                this.$refs.ref_file.value = '';
            },
            // 通知設定
            noticePost() {
                if (this.notice_browser) {
                    const applicationServerKey = this.base64toUint8(this.vapidPublicKey);
                    const options = {
                        userVisibleOnly: true,
                        applicationServerKey: applicationServerKey
                    };
                    this.registration.pushManager.subscribe(options)
                        .then(subscription => {

                            const form = reactive({
                                notice_mail: this.notice_mail,
                                notice_browser: this.notice_browser,
                                data: subscription,
                            })
                            this.$inertia.visit('/admin/account/set/notice',{
                                method: 'post',
                                preserveState: true,
                                preserveScroll: true,
                                data:{
                                    form: form,
                                },
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                },
                                onFinish: visit => {
                                    this.openAlertModal("success", '保存完了', '通知設定を保存しました。'); // can't get browser to OK notifications, or this doesn't work
                                },
                            })
                        })
                        .catch((error)=> {
                            this.openAlertModal("error", "エラー", '設定の通知を許可してください。'); // 確認済み
                        })
                        .finally(() => {
                        });
                } else {
                    this.registration.pushManager.getSubscription()
                        .then(subscription => {
                            if (subscription) {
                                subscription.unsubscribe()
                                .then(result => {
                                    if(result) {
                                        const form = reactive({
                                            notice_mail: this.notice_mail,
                                            notice_browser: this.notice_browser,
                                            data: subscription,
                                        })
                                        this.$inertia.visit('/admin/account/set/notice',{
                                            method: 'post',
                                            preserveState: true,
                                            preserveScroll: true,
                                            data:{
                                                form: form,
                                            },
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json',
                                            },
                                            onFinish: visit => {
                                                this.openAlertModal("success", '保存完了', '通知設定を保存しました。');
                                            },
                                        })
                                    }
                                });
                            } else {
                                const form = reactive({
                                    notice_mail: this.notice_mail,
                                    notice_browser: this.notice_browser,
                                    data: '',
                                })
                                this.$inertia.visit('/admin/account/set/notice',{
                                    method: 'post',
                                    preserveState: true,
                                    preserveScroll: true,
                                    data:{
                                        form: form,
                                    },
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                    onFinish: visit => {
                                        this.openAlertModal("success", '保存完了', '通知設定を保存しました。'); // 確認済み
                                    },
                                })
                            }
                        })
                        .finally(() => {
                        });
                }
            },
            base64toUint8(str) {
                str += '='.repeat((4 - str.length % 4) % 4);
                const base64 = str
                    .replace(new RegExp('\-', 'g'), '+')
                    .replace(new RegExp('_', 'g'), '/');

                const binary = window.atob(base64);
                const binaryLength = binary.length;
                let uint8Array = new Uint8Array(binaryLength);

                for(let i = 0; i < binaryLength; i++) {
                    uint8Array[i] = binary.charCodeAt(i);
                }
                return uint8Array.buffer;
            },
            changeNoticeMail() {
                var id = 'notice-checkbox1-1';
                var check = document.getElementById(id).checked;
                this.notice_mail = check;
            },
            changeNoticeBrowser() {
                var id = 'notice-checkbox1-2';
                var check = document.getElementById(id).checked;
                this.notice_browser = check;
            },
            webPush() {   // テストプッシュ通知をする
                this.$inertia.visit('/back-door/web_push', { method: 'post', preserveState: true, preserveScroll: true})
            },
            // パスワード設定
            mailSubmit() {
                this.$inertia.visit('/admin/account/set/password/token',{
                    method: 'post',
                    preserveState: true,
                    preserveScroll: true,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    onFinish: visit => {
                        this.openAlertModal("success", '送信完了', 'パスワード設定用のメールが送信されました。'); //確認済み
                    },
                })
            },
            passwordPost() {
                const form = {
                    password_current: this.password_current,
                    password: this.password,
                    token_id: this.token_id,
                }
                axios.post(route('admin.account.set.password.edit'), form)
                .then((res)=>{
                    location.reload();
                }).catch(error => {
                    if (error.response.data.errors.password) {
                        const message = error.response.data.errors.password[0];
                        this.openAlertModal("error", "エラー", message); //確認済み
                    }
                    if (error.response.data.errors.password_current) {
                        const message = error.response.data.errors.password_current[0];
                        this.openAlertModal("error", "エラー", message); //確認済み
                    }
                });
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = "";
                this.alert_modal_title = "";
                this.alert_modal_message = "";
            },
            async clickDeleteCompany() {
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '退会してもよろしいですか？',
                    message: '本当に退会してもよろしいですか？',
                    mode: "confirm",
                    name: "userSettingConfirm"
                })
                if (confirm) {
                    var routeName = 'admin.shop.delete.company';
                    axios.post(route(routeName))
                    .then(response => {
                        location.reload();
                    })
                }
            },
            async clickRecessCompany() {
                var routeName = 'admin.shop.recess.company';
                if (this.company.status == 1) {
                    // 休会
                    const confirm = await this.$refs.confirmModal.show({ // 確認済み
                        title: '休会してもよろしいですか？',
                        message: '本当に休会してもよろしいですか？',
                        mode: "confirm",
                        name: "userSettingConfirm"
                    })
                    if (confirm) {
                        axios.post(route(routeName))
                        .then(response => {
                            location.reload();
                        })
                    }
                } else {
                    const confirm = await this.$refs.confirmModal.show({ // 確認済み
                        title: '再開してもよろしいですか？',
                        message: '再開してもよろしいですか？？',
                        mode: "confirm",
                        name: "userSettingConfirm"
                    })
                    // 再開
                    if (confirm) {
                        axios.post(route(routeName))
                        .then(response => {
                            location.reload();
                        })
                    }
                }
            },
        },
    }
</script>
